import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { ProgressBar } from 'primereact/progressbar';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Login.css';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = () => {
    setIsLoading(true);

    let requestBody = new URLSearchParams();
    let loginType = '';

    // Determinar el tipo de inicio de sesión basado en la entrada
    if (isNumeric(username)) {
      // Si username es numérico, asumimos que es cedulaEmpleado
      loginType = 'cedulaEmpleado';
      requestBody.append('username', username);
    } else {
      // Si no es numérico, asumimos que es username
      loginType = 'username';
      requestBody.append('username', username);
    }

    requestBody.append('password', password);

    axios
      .post('/api/security/login', requestBody)
      .then((response) => {
        const { access_token, expires_in, refresh_token } = response.data;
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('expires_in', expires_in);
        localStorage.setItem('refresh_token', refresh_token);

        // Guardar el nombre de usuario o cédula de empleado en el almacenamiento local
        if (loginType === 'cedulaEmpleado') {
          localStorage.setItem('cedulaEmpleado', username);
        } else {
          localStorage.setItem('username', username);
        }

        // Guardar el correo electrónico del usuario en el almacenamiento local si es necesario
        const userInfo = parseJwt(access_token);
        localStorage.setItem('userEmail', userInfo.email);
        localStorage.setItem('userId', userInfo.id); // Guardar el userId en el localStorage

        setIsLoading(false);

        // Obtener roles del usuario después de iniciar sesión
        getRoles(access_token, loginType, username);
      })
      .catch((error) => {
        setError('Usuario o contraseña incorrectos');
        setIsLoading(false);
      });
  };

  const isNumeric = (value) => {
    return /^\d+$/.test(value);
  };

  const parseJwt = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  };

  const getRoles = (token, loginType, username) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  
    axios
      .get('/api/security/roles', config)
      .then((response) => {
        console.log('Roles del usuario:', response.data);
        if (loginType === 'cedulaEmpleado') {
          onLogin({ cedulaEmpleado: username, roles: response.data });
        } else {
          onLogin({ username: username, roles: response.data });
        }
      })
      .catch((error) => {
        console.error('Error al obtener los roles:', error);
      });
  };

  return (
    <div className="login-container">
      <Card className="login-card">
        <h2 className="login-title">Iniciar sesión</h2>
        <div>
          <div className="p-fluid">
            <div className="p-field">
              <span className="p-float-label">
                <InputText
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <label htmlFor="username">Número de Cédula o Usuario</label>
              </span>
            </div>
            <div className="p-field">
              <span className="p-float-label">
                <InputText
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <label htmlFor="password">Contraseña</label>
              </span>
            </div>
            {error && <div className="p-error">{error}</div>}
            <Button
              label={isLoading ? 'Cargando...' : 'Ingresar'}
              icon={isLoading ? 'pi pi-spin pi-spinner' : ''}
              onClick={handleLogin}
              disabled={isLoading}
              className="p-button-rounded p-button-lg p-button-primary p-button-raised p-button-text"
            />
            {isLoading && <ProgressBar mode="indeterminate" className="p-mt-2" />}
          </div>
        </div>
        <div className="forgot-password-link">
          <Link to="/forgotPassword">¿Olvidaste tu contraseña?</Link>
        </div>
        <div className="register-link">
          <Link to="/register">¿No tienes cuenta? Regístrate</Link>
        </div>
      </Card>
    </div>
  );
};

export default Login;
